import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { translation } from '@cue/translations';
import { ButtonComponent } from '@cue/assist/ui/buttons';
import { cueFinish, cueClose } from '@cue/ui/icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { ModalBodyComponent, ModalComponent, ModalFooterComponent, ModalHeaderComponent } from '@cue/modal';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SubjectPipe } from '@cue/pipes';
export type FinishReservationData = {
  reservation: any;
};

@Component({
  selector: 'cue-reservation-finish',
  templateUrl: './reservation-finish.component.html',
  styleUrls: ['./reservation-finish.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoPipe,
    ButtonComponent,
    ModalComponent,
    ModalBodyComponent,
    ModalHeaderComponent,
    ModalFooterComponent,
    SubjectPipe,
  ],
})
export class ReservationFinishComponent {
  translation = translation;

  modal = inject(DialogRef);
  modalData = inject<FinishReservationData>(DIALOG_DATA);
  cueClose = cueClose;
  cueFinish = cueFinish;
}
